import { Row, Col, Container as Grid } from "react-bootstrap";
import Breadcrumb from "components/core/blocks/Breadcrumb";
import PriceLog from "modules/pricingv2/components/PriceLog";

const PriceChanges = () => {
  const breadCrumbItems = [{ name: "Price Log", href: "/user/_pricing/changes" }];

  return (
    <>
      <Row style={{ marginBottom: "1rem" }}>
        <Col xs={12}>
          <Breadcrumb items={breadCrumbItems} />
        </Col>
      </Row>
      <div className="main-content" style={{ backgroundColor: "#FFF" }}>
        <Grid fluid style={{ minHeight: "calc(100vh - 150px)" }}>
          <PriceLog />
        </Grid>
      </div>
    </>
  );
};

export default PriceChanges;
